angular.module('qkr').directive('modalDialog', [function() {
    return {
        restrict: 'AC',
        link(scope, element) {
            const draggableStr = 'draggableModal';
            const header = $('.modal-header', element);

            header.on('mousedown', (mouseDownEvent) => {
                const modalDialog = element;
                const offset = header.offset();

                // move the modal on drag of the header
                modalDialog.addClass(draggableStr).parents().on('mousemove', (mouseMoveEvent) => {
                    $('.' + draggableStr, modalDialog.parents()).offset({
                        top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                        left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                    });
                }).on('mouseup', () => {
                    modalDialog.removeClass(draggableStr);
                });
            });
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/directives/move.modal.js